import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMedicalQuestionnaireTotalSections } from '../services/medicalQuestionnaire';
import { setMedicalQuestionnaireTotalSections } from '../store/medicalQuestionnaireProgressSlice';

/**
 * Load section count once so portal tracker can show "X of Y sections" (Y from API structure).
 * Completion percent comes from BE on the user profile, not from client-side answer counting.
 */
export default function useBootstrapMedicalQuestionnaireProgress(enabled) {
  const dispatch = useDispatch();
  const totalSections = useSelector(
    (s) => s.medicalQuestionnaireProgress?.totalSections ?? 0
  );

  useEffect(() => {
    if (!enabled || totalSections > 0) return undefined;

    const controller = new AbortController();
    let cancelled = false;

    (async () => {
      try {
        const count = await fetchMedicalQuestionnaireTotalSections({
          signal: controller.signal,
        });
        if (cancelled || count <= 0) return;
        dispatch(setMedicalQuestionnaireTotalSections(count));
      } catch (error) {
        const isRequestCancelled =
          controller.signal.aborted ||
          error?.name === 'AbortError' ||
          error?.code === 'ERR_CANCELED';
        if (isRequestCancelled) return;
      }
    })();

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [dispatch, enabled, totalSections]);
}
